<template>
    <div class="container">
        <div class="paramForm">
            <div class="paramFormButton">
                
            </div>
        </div>
        <div class="tableTool2">
            <el-button type="primary" icon="el-icon-refresh" @click="reload()">刷新</el-button>
            <div class="toolRight">
                <el-button type="primary" @click="sendFee">发放分红</el-button>
                <el-button type="warning" @click="openWithdraw">提现</el-button>
            </div>
        </div>
        <div>
            <el-form label-width="150px">
                <el-row>
                    <el-form-item label="分红池(待发放)：">
                        <span>{{ feeData.jdfhRemain }} USDT</span>
                        
                    </el-form-item>
                    <el-form-item label="分红池(已发放)：">
                        <span>{{ feeData.jdfhSend }} USDT</span>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="基金会：">
                        <span>{{ feeData.jjh }} USDT</span>
                    </el-form-item>
                    <el-form-item label="运营团队：">
                        <span>{{ feeData.yytd }} USDT</span>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="回流底池：">
                        <span>{{ feeData.hldc }} USDT</span>
                    </el-form-item>
                    <el-form-item label="销毁：">
                        <span>{{ feeData.xh }} USDT</span>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="借贷池利息：">
                        <span>{{ feeData.jdclx }} USDT</span>
                    </el-form-item>
                    <el-form-item></el-form-item>
                </el-row>
            </el-form>
        </div>
        <el-dialog title="池子提现" :visible.sync="withdrawDialogVisible" class="abow_dialog2" @close="withdrawDialogVisible = false" style="width: 500px;margin: auto;height: 260px;">
            <el-form label-width="120px">
                <el-row>
                    <el-form-item label="可提余额">
                        <span>{{ aldHomeUsdtBalance || 0 }} USDT</span>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="提现数量">
                        <el-input v-model.number="withdrawAmount" placeholder="输入提现数量" />
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmWithdraw">确认提现</el-button>
                <el-button @click="withdrawDialogVisible = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { aldServiceApi } from '@/api/api-ald';
import { exportData1,exportData2 } from '@/assets/js/exportExcel';
import Web3 from 'web3';
export default {
    data() {
        return {
            feeData:{},
            // wallet
            walletAddress: "",
            connected: false,
            web3Instance: null,
            aldHomeContractInstance: null,
            usdtTokenContractInstance: null,
            // withdraw
            withdrawDialogVisible: false,
            withdrawAmount: 0,
            // AldHome合约USDT余额
            aldHomeUsdtBalance: 0,
        };
    },
    created() {
        this.reload();
    },
    methods: {
        reload(){
            aldServiceApi.findFee().then(res => {
                this.feeData = res;
                this.hideLoadingBox();
            });
        },
        openWithdraw(){
            if(!this.connected){
                this.connectToMask(() => {
                    this.withdrawDialogVisible = true;
                });
                return;
            }
            this.withdrawDialogVisible = true;
        },
        connectToMask(next){
            let _this = this;
            this.connectWallet(function(address){
                _this.walletAddress = address;
                _this.web3Instance  = new Web3(window.ethereum);
                _this.aldHomeContractInstance = new _this.web3Instance.eth.Contract(_this.AldHome_Contract.abi,_this.AldHome_Contract.address);
                _this.usdtTokenContractInstance = new _this.web3Instance.eth.Contract(_this.UsdtToken_Contract.abi,_this.UsdtToken_Contract.address);
                _this.connected = true;
                // 获取AldHome合约的USDT余额
                _this.getAldHomeUsdtBalance();
                if(typeof next === 'function'){
                    next();
                }
            });
        },
        // 获取AldHome合约的USDT余额
        getAldHomeUsdtBalance(){
            if(this.usdtTokenContractInstance && this.AldHome_Contract){
                this.usdtTokenContractInstance.methods.balanceOf(this.AldHome_Contract.address).call().then((result) => {
                    this.aldHomeUsdtBalance = this.convertFromByUnit(result, 6);
                }).catch((error) => {
                    console.error('获取AldHome合约USDT余额失败:', error);
                    this.aldHomeUsdtBalance = 0;
                });
            }
        },
        async confirmWithdraw(){
            if(!this.aldHomeContractInstance || !this.walletAddress){
                this.$message.warning({message: "请先连接钱包",duration: 1500});
                return;
            }
            if(!this.withdrawAmount || this.withdrawAmount <= 0){
                this.$message.warning({message: "请输入正确的提现数量",duration: 1500});
                return;
            }
            // 可选校验：不可超过AldHome合约USDT余额
            if(this.aldHomeUsdtBalance != null && this.withdrawAmount > Number(this.aldHomeUsdtBalance)){
                this.$message.warning({message: "提现数量超过可提余额",duration: 1500});
                return;
            }
            try{
                this.showConfirmBox(2, 'USDT');
                const finalBigNumber = this.convertToBigNumberByUnit(this.withdrawAmount, 6);
                await this.contractSend(
                    this.aldHomeContractInstance.methods.withdrawFrom(finalBigNumber),
                    this.walletAddress,
                    0
                ).then((result)=>{
                    this.hideConfirmBox();
                    if(result && result.status){
                        this.withdrawDialogVisible = false;
                        this.withdrawAmount = 0;
                        this.reload();
                        // 刷新AldHome合约USDT余额
                        this.getAldHomeUsdtBalance();
                        this.$message.success({message: "提现成功",duration: 2000});
                    }else{
                        this.$message.error({message: "提现失败",duration: 1500});
                    }
                }).catch((error)=>{
                    this.hideConfirmBox();
                    this.$message.error({message: "交易发送失败",duration: 1500});
                });
            }catch (e){
                this.hideConfirmBox();
                this.$message.error({message: "提现异常",duration: 1500});
            }
        },
        sendFee(){
            if(this.feeData.jdfhRemain <=0){
                this.$message.warning({message: "没有待发放的手续费分红",duration: 1500})
                return;
            }
            this.$confirm('确认要发放手续费分红吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                aldServiceApi.sendFee().then(res => {
                    if (res.result) {
                        this.showLoadingBox();
                        this.reload();
                        this.$message.success("发放完成");
                    } else {
                        if(res.msg){
                            this.$message.error(res.msg);
                        }else{
                            this.$message.error("发放失败");
                        }
                    }
                });
            })
        },
        exportExcel() {
            if(!this.tableData || this.tableData.length==0){
                this.$message.warning({message: "没有可导出的数据",duration: 600})
                return;
            }
            let header = ['ID', '会员地址','奖励类型',"奖励金额","结算时间","发放状态","更新时间"];
            let columns = ['id','memberAddress','type','amount', 'createdAt','status', 'updatedAt'];
            let data = this.tableData.map(r => columns.map(c => {
                let val = r[c];
                return val;
            }));
            exportData2(header,data,"社区奖励记录");
        }
    }
};
</script>

<style lang='less' scope>
span.status_CANCEL{
    color:red;
}
span.status_CONFIRM{
    color:green;
}
span.status_PENDING{
    color:gray;
}
</style>